export default "__VITE_ASSET__2307609f__"